import Contact from "components/contact/contact";
import Footer from "components/footer/footer";
import Navbar from "components/navbar";
import "./about.css";
import Hero from "ui/about/hero";
import ChooseUs from "ui/home/choose-us";
import Mission from "ui/about/mission";
import Team from "ui/about/team/team";

const AboutPage = () => {
  return (
    <div>
      <Navbar active="about" />
      <Hero />
      <ChooseUs />
      <Mission />
      <Team />
      <Contact />
      <Footer />
    </div>
  );
};

export default AboutPage;
